/* eslint-disable react/require-default-props */
/* eslint-disable import/no-extraneous-dependencies */
/*
 This step has been overriden to use the personalized footer (footer id key) to link the professions faqs page
 since currently the professions page is not properly linked to help center
*/
import React from 'react';
import {
    VerificationService,
    Locale,
    ViewModel,
    getLocaleSafely,
    getSafe,
} from '@sheerid/jslib';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import produce from 'immer';

interface FormFooterProps {
    verificationService: VerificationService;
    children?: any;
}

const FormFooterComponent = ({ verificationService, children }: FormFooterProps) => {
    const { viewModel, updateViewModel } = verificationService;
    const countryChoice = getSafe<string>(() => viewModel.countryChoice.value, undefined);
    const locale: Locale = getLocaleSafely(viewModel);
    const privacyPolicyRef = React.useRef<any>({});
    const cleanupCommonTags = /(<div[^>]+>|<div>|<\/div>)|(<span[^>]+>|<span>|<\/span>)|(<p[^>]+>|<p>|<\/p>)/gm;

    // Store the footer message that the user was shown when the user submitted
    React.useEffect(() => {
        if (!privacyPolicyRef.current) {
            return;
        }
        const privacyPolicyText = privacyPolicyRef.current.innerHTML.replace(cleanupCommonTags, '');
        const updatedViewModel = produce(viewModel, (draft: ViewModel) => {
            if (!draft.metadata) {
                draft.metadata = {};
            }
            draft.metadata.submissionOptIn = privacyPolicyText;
        });

        updateViewModel(updatedViewModel);
    }, [privacyPolicyRef, locale]);

    return (
        <>
            <div className="sid-footer sid-h-small-text sid-l-space-top-md">
                <div>
                    <div className="sid-footer__one" ref={privacyPolicyRef}>
                        {children || (
                            <div>
                                <FormattedHTMLMessage
                                    id="infoShared1"
                                />
                                <FormattedMessage id="companyName" defaultMessage="{Company}">
                                    {companyName => (
                                        <FormattedHTMLMessage
                                            id="infoShared2"
                                            defaultMessage=". I understand that my information will be shared with {companyName}."
                                            values={{ companyName }}
                                        />
                                    )}
                                </FormattedMessage>
                                {
                                    typeof countryChoice === 'string' && countryChoice.length > 0 && countryChoice !== 'US'
                                        ? (
                                            <FormattedHTMLMessage
                                                id="informationTransferredToUS"
                                                defaultMessage="Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy."
                                            />
                                        )
                                        : null
                                }
                            </div>
                        )}
                    </div>
                    <div className="sid-footer sid-l-space-top-md">
                        <FormattedHTMLMessage
                            id="footer"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export { FormFooterComponent };
